import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Navbar from "./Components/Navbar/Navbar";
import Login from "./Components/Account/Login";
import Profile from "./Components/Account/Profile";
import RajasthaniGallery from "./Components/Catalog/RajasthaniGallery";
import DashboardLayout from "./Components/Dashboard/DashboardLayout";
import UploadImage from "./Components/Dashboard/UploadImage";
import ManageImage from "./Components/Dashboard/ManageImage";
import AntiqueGoldGallery from "./Components/Catalog/AntiqueGoldGallery";
import SilverGallery from "./Components/Catalog/SilverGallery";
import DesiGallery from "./Components/Catalog/DesiGallery";
import Logout from "./Components/Dashboard/Logout";

function App() {
  return (
    <>
      <div>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Routes>
            <Route path="/" element={<Navbar />} />
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin/profile" element={<Profile />} />
            <Route path="/admin/logout" element={<Logout />} />
            <Route path="/rajasthanigallery" element={<RajasthaniGallery />} />
            <Route path="/AntiqueGoldGallery" element={<AntiqueGoldGallery />} />
            <Route path="/DesiGallery" element={<DesiGallery />} />
            <Route path="/SilverGallery" element={<SilverGallery />} />
            <Route path="/admin/dashboard" element={<DashboardLayout />}>
            <Route path="/admin/dashboard/uploadimage" element={<UploadImage/>}/>
            <Route path="/admin/dashboard/manageimage" element={<ManageImage/>}/>
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </>
  );
}

export default App;
